import React, { forwardRef } from "react";
import { func } from "prop-types";

import { VisuallyHidden } from "../style-utilities/visually-hidden";
import closeIcon from "./assets";
import * as S from "./styled";

const CloseButton = forwardRef(({ onClick, ...passThroughProps }, ref) => (
  <S.Button ref={ref} onClick={onClick} {...passThroughProps}>
    <img alt="" src={closeIcon} />
    <VisuallyHidden>Close</VisuallyHidden>
  </S.Button>
));

CloseButton.propTypes = {
  onClick: func.isRequired
};

export default CloseButton;
